/**
 * Shared UI constants for consistent buttons and form patterns across all sidebar pages.
 * Use these for main content forms and actions (Users, Devices, Manufacturing, Statistics, Others).
 */

// Primary action: Submit, Search, Filter, Save, Get, Generate, Send
export const BTN_PRIMARY = "btn btn-style-2 orange-bg";

// Secondary action: Reset, Cancel, Clear
export const BTN_SECONDARY = "btn btn-style-2 dark-text gray-bg";

// Add / floating action (e.g. "Add new Job")
export const BTN_ADD_ACTION = "btn btn-style-3 orange-bg sm font-400 min-140";

// Search bar submit (User search, Device search)
export const BTN_SEARCH = "btn orange-bg btn-block md no-shadow";

// Common Button (MUI) – consistent height/width for Back, Search, primary actions on sidebar pages
export const ACTION_BUTTON_HEIGHT = 45;
export const ACTION_BUTTON_MIN_WIDTH = 100;

// Inline spacing for primary + secondary pair (use on primary)
export const BTN_PRIMARY_MARGIN = { marginRight: "12px" };

// Form layout: use md (960px) for desktop; only mobile/small screens get full-width stacked layout
export const FORM_GRID_LABEL = { xs: 12, md: 2 };
export const FORM_GRID_CONTROL = { xs: 12, md: 10 };
// Desktop input max width (match Firmware Distribution / old inputs style)
export const INPUT_DESKTOP_MAX_WIDTH = 280;

// Label style for form labels
export const LABEL_STYLE = { color: "black", fontSize: "14px" };
export const LABEL_CLASS = "title";

// Input style for full-width inputs
export const INPUT_FULL_WIDTH_STYLE = { width: "100%", boxSizing: "border-box" };

// Content block wrapper for form sections
export const CONTENT_BLOCK_STYLE = { width: "100%", minWidth: 0 };
